export const visit = (vm, at) => {
at({ "hu": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Sajn\xE1ljuk, nem tudtuk meger\u0151s\xEDteni az e-mail-c\xEDm\xE9t." } } } });
};